import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = { class: "bg-dark text-center my-5" }
const _hoisted_3 = {
  class: "py-5 image-header opacity-bg",
  style: {"background-image":"url('/images/restaurants-bg.png')"}
}
const _hoisted_4 = { class: "container container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-10 offset-md-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "text-white fw-bold mb-4" }, [
  /*#__PURE__*/_createTextVNode("Find a restaurant"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" and enjoy dining out with Picado")
], -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-5 d-flex mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "All Cuisines", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "All Cities", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-md-4 mb-2" }
const _hoisted_15 = { class: "search-input position-relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search text-secondary" }, null, -1)
const _hoisted_17 = { class: "col-md-3 mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_19 = { class: "container container-fluid" }
const _hoisted_20 = { class: "row restaurants-list" }
const _hoisted_21 = { class: "card shadow-sm rounded-3 border-0 h-100" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "card-body px-3" }
const _hoisted_24 = { class: "card-title fw-bold mb-1 text-black" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_27 = { class: "card-footer pb-3 bg-white border-0 mt-auto" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Book Now")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("View Details")
const _hoisted_30 = {
  key: 2,
  class: "fw-bold text-center mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_list_loader = _resolveComponent("list-loader")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select rounded-left white-select border-end border-0",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected_cuisine) = $event))
                  }, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cuisine_types, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type,
                        value: type.id
                      }, _toDisplayString(type.name), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selected_cuisine]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select rounded-right white-select border-0",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected_city) = $event))
                  }, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_cities, (city) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: city,
                        value: city.name
                      }, _toDisplayString(city.name), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selected_city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control rounded-5 border-0",
                      placeholder: "Search by retaurant name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search_text) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.search_text]
                    ]),
                    _hoisted_16
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-sm rounded-5 py-2 px-3 me-2 fw-bold w-100",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.allRestaurants()), ["prevent"]))
                  }, "Find a table")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.all_restaurants && _ctx.all_restaurants.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_restaurants, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col-lg-3 col-md-4 col-sm-6 mb-4"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: _ctx.restaurantURL(item.id, item.name)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.featured_photo_thumbnails.cover_small,
                          class: "card-img-top",
                          alt: item.name
                        }, null, 8, _hoisted_22),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("h6", _hoisted_24, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_25, [
                            (item.cuisines && item.cuisines.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.cuisines[0].name), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_26
                                ], 64))
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_27, [
                      (item.has_booking_only)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _ctx.restaurantURL(item.id, item.name) + '/book-table',
                            class: "btn btn-primary rounded-3 w-100 fw-bold"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: _ctx.restaurantURL(item.id, item.name),
                            class: "btn btn-primary2 rounded-3 w-100 fw-bold"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (!_ctx.no_records)
        ? (_openBlock(), _createBlock(_component_list_loader, { key: 1 }))
        : _createCommentVNode("", true),
    (_ctx.no_records)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_30, "No records found!"))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ]))
}